import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Basket = () => {
    document.title = "Səbət";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Göstəricilər", value: "/dashboard" },
        { name: "Səbət", value: "/dashboard/main", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Səbət</h2>
                    <p>
                        Silinən sənədlər və məhsullar ilk olaraq Səbət səhifəsində əks olunur. Səbət səhifəsində olan sənədləri bərpa etmək və səbətdən köklü
                        silmək mümkündür.
                        <ol>
                            <li>
                                <button style={{ color: "blue", border: "none" }}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-arrow-clockwise"
                                        viewBox="0 0 16 16"
                                    >
                                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"></path>
                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"></path>
                                    </svg>
                                </button>{" "}
                                düyməsi ilə silinmiş sənədi yenidən bərpa etmək mümkündür
                            </li>
                            <li>
                                <button style={{ color: "red", border: "none" }}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-trash3"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"></path>
                                    </svg>
                                </button>
                                düyməsi ilə səbətdəki sənədi köklü silmək olar
                            </li>
                            <li>
                                <button className="new-button">Səbəti təmizlə</button> Səbəti təmizlə düyməsi ilə səbətdəki sənədlərin hamısını köklü silmək
                                olar
                            </li>
                        </ol>
                    </p>
                    <img src="/images/dashboard/#.gif" alt="Səbət" />
                </article>
            </div>
        </div>
    );
};
